import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { methodSteps } from '../data/salesContent';
import { images } from '../data/siteConfig';
export function MethodSection() {
  return <section className="bg-white py-16 lg:py-24" data-id="element-113" data-mp="2tp4rgyboigw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-114" data-mp="2uifet0ejs4b">
        <div className="mx-auto max-w-2xl text-center" data-id="element-115" data-mp="3uyj91gnsnxnq">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-116" data-mp="3v046be1htupa">
            A Clear Process for Everyday Pool Care
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink" data-id="element-117" data-mp="qkuoi77dvuwh">
            Understand your setup, collect useful information, follow the appropriate instructions,
            and keep track of what happens next.
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-3 gap-3 sm:gap-4 lg:grid-cols-6 lg:gap-0" data-id="element-118" data-mp="hpondlj2610a">
          {methodSteps.map((step, i) => <li key={step} className="relative flex items-center" data-id="element-119" data-mp="19i5hxb6c3u40" data-mpi={i}>
              <div className="flex w-full flex-col items-center rounded-xl bg-mist px-2 py-4 lg:mx-2" data-id="element-120" data-mp="19gughi0d2yg2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" data-id="element-121" data-mp="1v4lcyrycj8zf">
                  {i + 1}
                </span>
                <span className="mt-2 font-display text-sm font-extrabold uppercase tracking-wider text-navy sm:text-base" data-id="element-122" data-mp="1lacvczaut0g1">
                  {step}
                </span>
              </div>
              {i < methodSteps.length - 1 && <ChevronRightIcon className="absolute -right-3.5 top-1/2 z-10 hidden h-5 w-5 -translate-y-1/2 text-aqua lg:block" aria-hidden="true" data-id="element-123" data-mp="1hbdkyz6csbh7" />}
            </li>)}
        </ol>

        <figure className="mx-auto mt-12 max-w-4xl" data-id="element-124" data-mp="17er1adprjqgr">
          <img src={images.methodSpread} alt="Inside page from the guide showing the six-step pool care process" className="w-full rounded-2xl border border-line shadow-[0_20px_50px_rgba(16,48,71,0.12)]" data-id="element-125" data-mp="2wsnphp736cyj" />
          <figcaption className="mt-3 text-center text-sm text-ink" data-id="element-126" data-mp="3075rg2bnu3aa">
            A real page from inside the guide.
          </figcaption>
        </figure>
      </div>
    </section>;
}